import Facade from '@/Facade'
import GameSignals from '@/signals/GameSignals'
import { GameStatesEnum } from '@/states/GameStatesEnum'
import { RoundRestoreUtil } from '@/utils/RoundRestoreUtil'
import { BaseState } from '@stateMachine/BaseState'

export class StartRoundState extends BaseState {
    public begin() {
        RoundRestoreUtil.startRound()

        const wasFreeSpinsBeforeReset = Boolean(this._model.roundState.isFreeSpins)
        const isHoldAndWinBeforeReset = Boolean(this._model.spinState.isHoldAndWinActive)

        // Allow a fresh H&W end summary / Win Meter credit on later features.
        ;(Facade as any).holdAndWinSummaryConsumed = false
        ;(Facade as any).holdAndWinWinMeterCommitted = false

        this._model.resetRoundState()

        if (wasFreeSpinsBeforeReset) {
            this._model.roundState.isFreeSpins = true
            this._model.isBonusGameNow = true
        }

        if (isHoldAndWinBeforeReset) {
            this._model.spinState.isHoldAndWinActive = true
            this._model.isBonusGameNow = true
        }

        this._model.winCounter.startRound()
        GameSignals.roundStart.emit(false)

        this.end()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.START_SPIN_STATE)
    }

    public cleanUp() {
        // empty
    }
}
